/*
 * @Description: 销售订单api
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { BaseService } from './base-service';

class SalesOrderService extends BaseService {
  /********************************
   * 销售订单
   ********************************/
  /**
   * @description: 订单基本信息
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getOrder(data) {
    return this.request({
      method: 'GET',
      url: `/order/get`,
      params: data
    });
  }
  /**
   * @description: 订单基本--作废订单
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  delOrder(data) {
    return this.request({
      method: 'GET',
      url: `/order/del`,
      params: data
    });
  }
  /**
   * @description: 客户及商机获取销售订单
   * @param {*} params
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getOrderTabList(params) {
    console.log(params);
    return this.request({
      method: 'get',
      url: `/order/list/${params.entity}/${params.id}`,
      params
    });
  }
  /********************************
   * 退货单
   ********************************/
  /**
   * @description: 退货单--添加明细--获取销售订单列表
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getOrderList(data) {
    return this.request({
      method: 'post',
      url: `/order/getOrderList`,
      data
    });
  }
  /**
   * @description: 退货单--添加明细--获取销售订单列表--产品列表
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getProductByOrderId(data) {
    return this.request({
      method: 'post',
      url: `/order/productByOrderId`,
      params: { apiIndex: `${data.entityType}-${Math.random() * 100}` },
      data
    });
  }

  /**
   * @description: 退货单操作按钮
   * @param {*} data
   * @return {*}
   * @author: ldd
   */
  deleteSalesReturn(params) {
    return this.request({
      method: 'get',
      url: `/return/del`,
      params
    });
  }
}

export const salesOrderService = new SalesOrderService();
